const gradientStops = [
	{ pct: 0,   rgb: [247,  37, 133] }, // hot pink
	{ pct: 33,  rgb: [128,   0, 204] }, // vivid purple
	{ pct: 66,  rgb: [ 45,   0, 130] }, // deep indigo
	{ pct: 100, rgb: [ 53,  53, 245] }, // bright blue
];

export const availabilityColor = (availability: number | null): string => {
	if (availability === null) return "#A8B5E0";
	const v = Math.max(0, Math.min(100, availability));
	for (let i = 0; i < gradientStops.length - 1; i++) {
		const lo = gradientStops[i];
		const hi = gradientStops[i + 1];
		if (v <= hi.pct) {
			const t = (v - lo.pct) / (hi.pct - lo.pct);
			const r = Math.round(lo.rgb[0] + t * (hi.rgb[0] - lo.rgb[0]));
			const g = Math.round(lo.rgb[1] + t * (hi.rgb[1] - lo.rgb[1]));
			const b = Math.round(lo.rgb[2] + t * (hi.rgb[2] - lo.rgb[2]));
			return `rgb(${r},${g},${b})`;
		}
	}
	return `rgb(${gradientStops.at(-1)!.rgb.join(",")})`;
};
